export enum PartnerStatusCode {
  Aktīvs = 'SAKT',
  Bloķēts = 'SBLK',
  Jauns = 'SJAU',
  Neaktīvs = 'SNKT',
}
